<template>
  <div class="flex flex-col">
    <div class="font-bold">
      {{ busStopTypeDisplay }}
    </div>
    <span class="ml-4">{{ busStopDisplay }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    busStopData: Object,
  },
  computed: {
    busStopDisplay() {
      return this.busStopData?.description
    },
    busStopTypeDisplay() {
      switch (this.type) {
        case 'pickup':
          return 'Pickup Bus Stop'
        case 'dropoff':
          return 'Dropoff Bus Stop'
        default:
          return 'Bus Stop'
      }
    },
  }
}
</script>
